/**
 * System Questionnaires - Common (shared across all clinic types)
 *
 * These are read-only, hard-coded questionnaires available to all therapists.
 * Users can duplicate them to create editable cloud copies.
 */

import { ALL_CLINIC_TYPE_CODES } from "../../clinicTypesConfig";

export const commonQuestionnaires = [
  {
    id: "sys_quest_treatment_feedback",
    name: "שאלון חוות דעת על הטיפול",
    fields: [
      {
        id: "sq_fb_01",
        type: "radio",
        label: "עד כמה את/ה מרוצה מהטיפול עד כה?",
        required: true,
        options: ["מרוצה מאוד", "מרוצה", "בינוני", "לא כל כך מרוצה", "לא מרוצה"],
      },
      {
        id: "sq_fb_02",
        type: "radio",
        label: "באיזו מידה הרגשת שמקשיבים לך ומבינים אותך במפגשים?",
        required: true,
        options: ["במידה רבה מאוד", "במידה רבה", "במידה בינונית", "במידה מועטה"],
      },
      {
        id: "sq_fb_03",
        type: "long_text",
        label: "מה עזר לך במיוחד בתהליך?",
        required: false,
      },
      {
        id: "sq_fb_04",
        type: "long_text",
        label: "מה היית משפר/ת או משנה?",
        required: false,
      },
      {
        id: "sq_fb_05",
        type: "radio",
        label: "האם היית ממליץ/ה על הטיפול לאחרים?",
        required: true,
        options: ["בהחלט כן", "כנראה שכן", "לא בטוח/ה", "לא"],
      },
    ],
    isSystem: true,
    clinicTypes: ALL_CLINIC_TYPE_CODES,
  },
];
